export const blue = 'rgb(17 119 187)';
export const red = '#E39C9C';
export const gray = '#cccccc';
